import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { clerk } from './Reducers/Clerk.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { overlay } from './Reducers/Overlay.reducer';
import { wishList } from './Reducers/WishList.reducer';
import { login } from './Reducers/Login.reducer';
import { productListing } from './Reducers/ProductListing.reducer';
import { userInfo } from './Reducers/UserInfo.reducer';
import { registerOptions } from './Reducers/RegisterForm.reducer';
import { quickOrder } from './Reducers/QuickOrder.reducer';
import { productFiltering } from './Reducers/ProductFiltering.reducer';
import { site } from './Reducers/Site.reducer';

const staticReducers = {
    cart,
    quickSearch,
    clerk,
    navigation,
    facetedSearch,
    checkout,
    myPage,
    overlay,
    productListing,
    login,
    userInfo,
    wishList,
    registerOptions,
    quickOrder,
    productFiltering,
    site
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });
};

export default app;
